import { useEffect } from "react";

const APP_NAME = "JumpBean";

/**
 * Hook to update the document title for accessibility and browser tab display.
 * Automatically appends the app name suffix.
 *
 * @param title - The page-specific title to display
 *
 * @example
 * usePageTitle("Play"); // Sets title to "Play - JumpBean"
 * usePageTitle("Level 1 - Math"); // Sets title to "Level 1 - Math - JumpBean"
 */
export function usePageTitle(title: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `${title} - ${APP_NAME}` : APP_NAME;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
}

export default usePageTitle;
